<template>
  <div class="login-container">
    <div class="row">
      <div class="col-6">
        <div class="login-header">
          <img src="src/assets/wasyyah_logo.jpeg" alt="Al Wasyyah Logo" class="logo">
        </div>
        <div class="login-options">
          <!-- Buttons to select each form -->
          <b-button class="btn btn-info" @click="selectForm('nominee')">Nominee Log in</b-button>
          <b-button class="btn btn-info" @click="selectForm('finance')">Finance</b-button>
          <b-button class="btn btn-info" @click="selectForm('application')">Application</b-button>
        </div>
      </div>

      <!-- Form container -->
      <div class="col-6 mt-4">
        <transition name="fade">
          <div v-if="selectedForm === 'default'">
            <!-- Default Form -->
            <b-form class="login-form" @submit.prevent="onSubmit()" @reset.prevent="onReset()">
              <h3>Default Login Form</h3>
              <div class="row">
                <div class="col-12 mt-4">
                  <b-form-input type="email" class="form-control" v-model="formData.email" placeholder="Email" required></b-form-input>
                </div>
                <div class="col-12 mt-4">
                  <b-form-input type="password" class="form-control" v-model="formData.password" placeholder="Password" required></b-form-input>
                </div>
                <div class="col-6 mt-4 login-btn">
                  <b-button type="submit" class="btn btn-success">Log in</b-button>
                </div>
              </div>
            </b-form>
          </div>

          <!-- Nominee Login Form -->
          <div v-else-if="selectedForm === 'nominee'">
            <b-form class="login-form" @submit.prevent="onSubmit()" @reset.prevent="onReset()">
              <h3>Nominee Login</h3>
              <div class="row">
                <div class="col-12 mt-4">
                  <b-form-input type="email" class="form-control" v-model="formData.email" placeholder="Nominee Email" required></b-form-input>
                </div>
                <div class="col-12 mt-4">
                  <b-form-input type="password" class="form-control" v-model="formData.password" placeholder="Nominee Password" required></b-form-input>
                </div>
                <div class="col-6 mt-4">
                  <b-button type="submit" class="btn btn-success">Log in as Nominee</b-button>
                </div>
              </div>
            </b-form>
          </div>

          <!-- Finance Login Form -->
          <div v-else-if="selectedForm === 'finance'">
            <b-form class="login-form" @submit.prevent="onSubmit()" @reset.prevent="onReset()">
              <h3>Finance Login</h3>
              <div class="row">
                <div class="col-12 mt-4">
                  <b-form-input type="email" class="form-control" v-model="formData.email" placeholder="Finance Email" required></b-form-input>
                </div>
                <div class="col-12 mt-4">
                  <b-form-input type="password" class="form-control" v-model="formData.password" placeholder="Finance Password" required></b-form-input>
                </div>
                <div class="col-6 mt-4">
                  <b-button type="submit" class="btn btn-success">Log in as Finance</b-button>
                </div>
              </div>
            </b-form>
          </div>

          <!-- Application Login Form -->
          <div v-else-if="selectedForm === 'application'">
            <b-form class="login-form" @submit.prevent="onSubmit()" @reset.prevent="onReset()">
              <h3>Application Login</h3>
              <div class="row">
                <div class="col-12 mt-4">
                  <b-form-input type="email" class="form-control" v-model="formData.email" placeholder="Application Email" required></b-form-input>
                </div>
                <div class="col-12 mt-4">
                  <b-form-input type="password" class="form-control" v-model="formData.password" placeholder="Application Password" required></b-form-input>
                </div>
                <div class="col-6 mt-4">
                  <b-button type="submit" class="btn btn-success">Log in as Application</b-button>
                </div>
              </div>
            </b-form>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'LogIn',
  data() {
    return {
      selectedForm: 'default', // Show default form on initial load
      formData: {
        email: null,
        password: null
      }
    };
  },
  methods: {
    selectForm(formType) {
      // Set the selected form based on the button click
      this.selectedForm = formType;
    },
    async onSubmit() {
      // Example login logic
      axios.get('http://localhost:3000/userSignUp')
          .then(response => {
            const user = response.data.find(user => user.email === this.formData.email && user.password === this.formData.password);
            if (user) {
              localStorage.setItem('auth', true);
              alert(`Login successful for ${this.selectedForm}! Redirecting to home page...`);
              this.$router.push('/');
            } else {
              alert('Invalid email or password. Please try again.');
            }
          })
          .catch(error => {
            console.error('Error fetching users:', error);
            alert('An error occurred while trying to log in. Please try again later.');
          });
    }
  }
};
</script>

<style scoped>
#login-button {
  font-size: large;
  padding: 20px 100px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.login-options b-button{
  padding: 10px;
}
.login-btn b-button{
  padding-left: 50px;
  padding-right: 50px;
}
</style>
